import { Card } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import ExportButton from "@/components/Export/ExportButton";
import ExportDatasetButton from "@/components/Export/ExportDatasetButton";

import ImportContext from "./ImportContext";
import UploadForm from "./UploadForm";

const InsertCard = ({ model, modelName, selectedTemplateId = null }) => {
  const { t } = useTranslation();

  const exportButton =
    model === "datasets" ? (
      <ExportDatasetButton
        templateId={selectedTemplateId}
        params={{
          "page[size]": 0,
        }}
        label={t("importTool:import.insertForm.exportTemplate")}
      />
    ) : (
      <ExportButton
        model={model}
        params={{
          "page[size]": 0,
        }}
        label={t("importTool:import.insertForm.exportTemplate")}
      />
    );

  return (
    <ImportContext.Provider value={{ model, modelName, operation: "insert" }}>
      <Card
        title={t("importTool:import.insertForm.title", { model: modelName })}
        extra={exportButton}
      >
        <UploadForm />
      </Card>
    </ImportContext.Provider>
  );
};

InsertCard.propTypes = {
  model: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
  selectedTemplateId: PropTypes.number,
};

export default InsertCard;
